// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"c90d8d80","344":"611d6ebc","543":"e1b43a7f","632":"6cb35e84"}[chunkId] + ".chunk.css";
};